import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";

@Component({
  selector: 'app-delete-team-member-dialog',
  standalone: true,
  imports: [TranslocoPipe, CustomButtonComponent],
  templateUrl: './delete-team-member-dialog.component.html',
  styleUrl: './delete-team-member-dialog.component.css'
})
export class DeleteTeamMemberDialogComponent {
  modalDialogId: string = 'settings_modal_delete_team_member';
  private dialogResponsePromise!: (value: boolean) => void;

  openModal(): Promise<boolean> {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      return new Promise<boolean>((resolve) => { this.dialogResponsePromise = resolve; });
    }

    return Promise.resolve(false);
  }

  closeModal(dialogResponse: boolean): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
      this.dialogResponsePromise(dialogResponse);
    }
  }
}
